import { useState } from "react";
import { CoursesTable } from "../courses-table";
import { Modal, Space, Tooltip } from "antd";
import { HiPencilSquare } from "react-icons/hi2";
import type { ColumnsType } from "antd/es/table";
import { produce } from "immer";

import { StringHelper } from "../../../../../../helper";
import { CreateCourseForm } from "../create-course-form";
import { useCourseColumns } from "../../hooks";

interface EditCourseTableProps {
  value: any[];
  onChange: (value: any[]) => void;
  disabledFields?: string[];
  hiddenFields?: string[];
  isEditing?: boolean;
}

export const EditCourseTable = (props: Partial<EditCourseTableProps>) => {
  const {
    value = [],
    onChange = () => {},
    disabledFields = [],
    hiddenFields = [],
    isEditing = false,
  } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const { columns } = useCourseColumns();

  const onCloseModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const onSubmit = (values: any) => {
    const newValues = produce(value, (draft) => {
      if (!values?.key) {
        draft.push({
          ...values,
          key: StringHelper.random(),
          eTrainees: [],
          eLessonTypes: [],
          eCoursePlaces: [],
          eDateTime: [],
        });
        return;
      }
      const courseIndex = draft.findIndex((e: any) => e.key === values.key);
      draft[courseIndex] = values;
    });
    onChange(newValues);
    onCloseModal();
  };

  const onEdit = (record: any) => {
    const course = value.find((e: any) => e.key === record.key);
    setSelectedItem(course);
    setTimeout(() => setIsModalOpen(true), 0);
  };

  const createColumns: ColumnsType<any> = [
    ...(isEditing
      ? [
          {
            key: "action",
            dataIndex: "action",
            width: 30,
            align: "left" as const,
            render: (_: string, record: any) => (
              <Space>
                <Tooltip title="Chỉnh sửa">
                  <HiPencilSquare
                    size={20}
                    className="cursor-pointer"
                    color="#0ea5e9"
                    onClick={() => onEdit(record)}
                  />
                </Tooltip>
              </Space>
            ),
          },
        ]
      : []),
    ...columns,
  ];

  return (
    <div>
      <CoursesTable
        dataSource={value}
        columns={createColumns}
        scroll={{ x: 2000 }}
      />
      <Modal
        className="modal-full"
        title={
          <div style={{ fontSize: 18 }}>
            Thêm thông tin kế hoạch đào tạo tháng
          </div>
        }
        open={isModalOpen}
        footer={null}
        onCancel={onCloseModal}
        destroyOnClose
      >
        <CreateCourseForm
          onSubmit={onSubmit}
          course={selectedItem}
          disabledFields={disabledFields}
          hiddenFields={hiddenFields}
        />
      </Modal>
    </div>
  );
};
